import { Injectable } from '@angular/core';
import {
  Resolve, RouterStateSnapshot, ActivatedRouteSnapshot
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { EventSearchParametersStore } from './event-search-parameters.store';
import { OrderedSet } from 'immutable';
import { SearchEventUtils } from '../utils/search-event-utils';
import { LogService } from '../../shared/log/log.service';
import { EventSearchFilter } from '../models/event-filter';
import { of } from 'rxjs/observable/of';

@Injectable()
export class EventListResolver implements Resolve<any> {

  constructor(private searchParametersStore: EventSearchParametersStore,
              private logService: LogService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const searchTextList: OrderedSet<string> = SearchEventUtils.convertParamsToSearchTextSet(route.queryParams);
    const searchFilterList: OrderedSet<EventSearchFilter> = SearchEventUtils.convertParamsToSearchFilterSet(route.queryParams);

    if (searchTextList.isEmpty() && searchFilterList.isEmpty()) {
      this.searchParametersStore.reset(true);
    } else {
      if (searchTextList) {
        this.searchParametersStore.setSearchTextSet(searchTextList);
      }
      if (searchFilterList) {
        this.searchParametersStore.setFilterSet(searchFilterList);
      }
    }

    this.logService.debug('route.url: ' + route.url);
    this.logService.debug('state.url: ' + state.url);

    if (route.data && route.data[ 'view' ]) {
      this.logService.debug('route.data[ \'view\' ]: ' + route.data[ 'view' ]);
      const showDefaultView = route.data['view'] as string;
      this.logService.debug('showDefaultView: ' + showDefaultView);

      this.searchParametersStore.setDefaultViewSelected(showDefaultView === 'default');
    }
    return of({status: 'event-resolver'});
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/event-list.resolver.ts